import { connect } from 'react-redux'
import { updateOrderData, loadProductScheduleSlotsData, loadProductScheduleSlotsDataAndCalculateStep, selectProductScheduleSlot, submitCalendarForm } from '../actions'
import orderSelector from '../selectors/orderSelector'
import NewOrderSlotsCalendar from '../components/NewOrderSlotsCalendar'
import NewOrderSlotsListing from '../components/NewOrderSlotsListing'
import ReactTooltipTrigger from '../../../components/ReactTooltipTrigger'

const mapStateToProps = (state) => {
  return {
    order: orderSelector(state),
    product_schedule_slots: state.product_schedule_slots,
    productScheduleSlotsLoading: state.productScheduleSlotsLoading,
    lastSlotSelectDate: state.lastSlotSelectDate,
    errors: state.errors,
    windowWidth: state.window && state.window.width,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateOrderData: data => dispatch(updateOrderData(data)),
    loadProductScheduleSlotsData: (data) => dispatch(loadProductScheduleSlotsData(data)),
    loadProductScheduleSlotsDataAndCalculateStep: (data) => dispatch(loadProductScheduleSlotsDataAndCalculateStep(data)),
    selectProductScheduleSlot: slot => dispatch(selectProductScheduleSlot(slot)),
    submitForm: () => dispatch(submitCalendarForm()),
  }
}

class NewOrderScheduleForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {}
  }

  _calculateNumberOfMonths() {
    const slots = this.props.product_schedule_slots
    const firstStock = slots[0]
    const lastStock = slots[slots.length - 1]
    const minDate = firstStock && firstStock.start_date
    const maxDate = lastStock && lastStock.start_date

    let n = 3;

    if (window.innerWidth && !st.Media.isMin("sm", window.innerWidth)) {
      n = Math.min(n, 2)
    }

    if (window.innerWidth && !st.Media.isMin("xs", window.innerWidth)) {
      n = Math.min(n, 1)
    }

    return n
  }

  handleFormSubmit(event) {
    event.preventDefault();

    this.setState({ isCalendarFormLoading: true })
    this.props.submitForm()
      .then(
        () => this.setState({ isCalendarFormLoading: false }),
        e => {
          this.setState({ isCalendarFormLoading: false })
          throw e
        }
      )
      .then(() => this.props.onSave())
  }

  handleSlotSelect(slot) {
    $(window.document.body).toggleClass("has-new-order-slot-selected", true)
    this.props.selectProductScheduleSlot(slot)
  }

  handleInitialSlotsLoad(startDate, endDate, includeId = "") {
    const data = {
      startDate: startDate,
      endDate: endDate,
      includeId: includeId,
    }

    this.props.loadProductScheduleSlotsDataAndCalculateStep(data);
  }

  handleSlotsLoad(startDate, endDate, includeId = "") {
    const data = {
      startDate: startDate,
      endDate: endDate,
      includeId: includeId,
    }

    this.props.loadProductScheduleSlotsData(data);
  }

  renderBaseErrors() {
    const errors = _(this.props.errors).values().flatten().value();

    return errors.length > 0 && (
      <div className="alert alert-danger">
        {errors.map((error, i) => <p key={i}>{error}</p>)}
      </div>
    );
  }

  renderCalendarHelp(dateType = "start") {
    return (
      <div className="reservation-calendar-help">
        <div className="reservation-calendar-help-label">{I18n.t("fe.NewOrderCalendarForm.help_tip")}:</div>

        <ReactTooltipTrigger tooltip={I18n.t("fe.NewOrderCalendarForm.stock_available")}>
          <div className="reservation-calendar-help-square is-available is-accessible">
            <div className="pika-day"></div>
          </div>
        </ReactTooltipTrigger>

        {!this.props.order.data.app_config.marketplace && (
          <ReactTooltipTrigger tooltip={I18n.t("fe.NewOrderCalendarForm.stock_confirmed")}>
            <div className="reservation-calendar-help-square is-available is-accessible is-confirmed">
              <div className="pika-day"></div>
            </div>
          </ReactTooltipTrigger>
        )}

        <ReactTooltipTrigger tooltip={I18n.t("fe.NewOrderCalendarForm.stock_discounted")}>
          <div className="reservation-calendar-help-square is-available is-accessible is-discounted">
            <div className="pika-day"></div>
          </div>
        </ReactTooltipTrigger>

        {this.props.order.data.booking_type == "fluid_date_booking" && (
          <ReactTooltipTrigger tooltip={I18n.t(`fe.NewOrderCalendarForm.stock_available_but_impossible_as_${dateType}`)}>
            <div className="reservation-calendar-help-square is-available is-inaccessible is-disabled">
              <div className="pika-day"></div>
            </div>
          </ReactTooltipTrigger>
        )}

        <ReactTooltipTrigger tooltip={I18n.t("fe.NewOrderCalendarForm.stock_busy")}>
          <div className="reservation-calendar-help-square is-busy">
            <div className="pika-day"></div>
          </div>
        </ReactTooltipTrigger>
      </div>
    );
  }

  renderSlots() {
    if (this.props.order.product.enable_frontend_slots_listing) {
      return (
        <div className="u-marginBottom">
          <NewOrderSlotsListing
            product={this.props.order.product}
            slots={this.props.product_schedule_slots}
            selectedSlot={this.props.order.product_schedule_slot}
            onSlotSelect={this.handleSlotSelect.bind(this)}
            onInitialSlotsLoad={this.handleInitialSlotsLoad.bind(this)}
            />
        </div>
      )
    } else {
      return (
        <div className="reservation-calendar-container active">
          {this.renderCalendarHelp()}
          <NewOrderSlotsCalendar
            product={this.props.order.product}
            slots={this.props.product_schedule_slots}
            lastSlotSelectDate={this.props.lastSlotSelectDate}
            numberOfMonths={this._calculateNumberOfMonths()}
            selectedSlot={this.props.order.product_schedule_slot}
            selectedSlotId={this.props.order.data.product_schedule_slot_id}
            onSlotSelect={this.handleSlotSelect.bind(this)}
            onInitialSlotsLoad={this.handleInitialSlotsLoad.bind(this)}
            onSlotsLoad={this.handleSlotsLoad.bind(this)}
            slotsLoading={this.props.productScheduleSlotsLoading}
            />
        </div>
      )
    }
  }

  renderOrderProductDescription() {
    return !!this.props.order.product_schedule_slot && (
      <div className="order-description">
        <div className="order-description-text">
          <div className="order-description-title">
            <span>{I18n.tt("fe.NewOrderCalendarForm.product_chosen", {
              name: (
                <strong>
                  {this.props.order.data.product_variant_name}
                </strong>
              ),
              date_range: st.formatTimeRange(this.props.order.data.stock_starts_at, this.props.order.data.stock_ends_at, { includeTime: this.props.order.data.stock_includes_time })
            })}</span>
          </div>
        </div>

        <div className="order-description-button order-description-button-sticky">
          <a
            className="btn btn-lg btn-primary"
            onClick={this.handleFormSubmit.bind(this)}
            disabled={this.state.isCalendarFormLoading}>
            {I18n.t("fe.NewOrderCalendarForm.submit")}
          </a>
        </div>
      </div>
    );
  }

  render() {
    const numberOfSlots = this.props.product_schedule_slots.length;
    const slotsLoading = this.props.productScheduleSlotsLoading;

    return (
      <form
        onSubmit={this.handleFormSubmit.bind(this)}
        className="form form-horizontal NewOrderScheduleForm">
        {numberOfSlots == 0 && !slotsLoading && (
          <div className="alert alert-warning">
            {(this.props.order.data.app_config.marketplace && !this.props.order.data.app_config.is_reseller) && (
              I18n.tt("fe.NewOrderView.marketplace_booking_unavailable_message_html", {
                email: <a href={`mailto:${this.props.order.data.app_config.contact_email}`}>{this.props.order.data.app_config.contact_email}</a>,
                phone_number: <a href={`tel:${this.props.order.data.app_config.contact_phone_number}`}>{this.props.order.data.app_config.contact_phone_number}</a>,
                open_chat: <a href="javascript:zEmbed.activate()">{I18n.t("fe.NewOrderView.open_chat")}</a>,
              })
            )}
            {(this.props.order.data.app_config.is_reseller) && (
              I18n.tt("fe.NewOrderView.saas_booking_unavailable_message_html", {
                email: <a href={`mailto:${I18n.tt("fe.tripsomnia_contact_email")}`}>{I18n.tt("fe.tripsomnia_contact_email")}</a>,
                phone_number: <a href={`tel:${I18n.tt("fe.tripsomnia_contact_phone_number")}`}>{I18n.tt("fe.tripsomnia_contact_phone_number")}</a>,
              })
            )}
            {(!this.props.order.data.app_config.marketplace && !this.props.order.data.app_config.is_reseller) && (
              I18n.tt("fe.NewOrderView.saas_booking_unavailable_message_html", {
                email: <a href={`mailto:${this.props.order.data.app_config.contact_email}`}>{this.props.order.data.app_config.contact_email}</a>,
                phone_number: <a href={`tel:${this.props.order.data.app_config.contact_phone_number}`}>{this.props.order.data.app_config.contact_phone_number}</a>,
              })
            )}
          </div>
        )}

        {numberOfSlots == 0 && slotsLoading &&
          <div className="NewOrderScheduleForm-loader">
            <i className="spinner fa fa-spin fa-circle-o-notch"></i>
          </div>
        }

        <div hidden={numberOfSlots == 0}>
          {this.renderSlots()}
          {this.renderBaseErrors()}
          {this.renderOrderProductDescription()}
        </div>
      </form>
    );
  }
}

const ConnectedNewOrderScheduleForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(NewOrderScheduleForm)

export default ConnectedNewOrderScheduleForm



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/containers/NewOrderScheduleForm.jsx